<template>
  <div>
    <div class="member-main-tab">
      <ul class="main-tab">
        <li class="active">我的直播</li>
      </ul>
    </div>

    <div class="member-main-body live-main-body">
      <div v-for="(item, index) in list" :key="index">
        <div class="right-box" v-if="item.type == 1">
          <div class="box1" style="justify-content: flex-start; width: 100%;">
            <div class="box1-left">
              <img src="https://shijizhongshi-image.obs.cn-north-4.myhuaweicloud.com/2022/10/27/2824444072674986593/657b37c170281053d49d5cb90afd3f5.png" alt="">
            </div>
            <div class="box1-right">
              <!-- <div class="live-type-name"> {{item.cate_name}} </div> -->
              <div v-if="item.status == 1 || item.status == 2">
                <router-link :to="{ name: 'Liveroom', params: { lid: item.id } }">
                  <div class="live-name"> {{item.title}} </div>
                </router-link>
              </div>
              <div v-if="item.status == 3">
                <router-link v-if="item.video_id" :to="{ name: 'Liveback', params: { lid: item.id } }">
                  <div class="live-name"> {{item.title}} </div>
                </router-link>
                <div v-else class="live-name"> {{item.title}} </div>
              </div>
              <div class="live-tearcher"> {{item.teacher}} {{item.start_time}} </div>
            </div>
          </div>
          <div class="right-live">
            <div v-if="item.status == 1">
              <router-link :to="{ name: 'Liveroom', params: { lid: item.id } }">
                <div class="live-btn"> 未开始 </div>
              </router-link>
            </div>
            <div v-if="item.status == 2">
                <router-link :to="{ name: 'Liveroom', params: { lid: item.id } }">
                  <div class="live-btn start-live"> 直播中 </div>
                </router-link>
            </div>
            <div v-if="item.status == 3">
              <router-link v-if="item.video_id" :to="{ name: 'Liveback', params: { lid: item.id } }">
                <div class="live-btn back-live"> 直播回放 </div>
              </router-link>
              <div v-else class="live-btn"> 已结束 </div>
            </div>
            <!-- <a v-if="item.notes" :href="item.notes" class="notes-down" target="_blank">
              讲义下载
            </a> -->
          </div>
          <div v-if="item.notes" class="notesbox">
            <a v-for="(it, ix) in item.notes" :key="ix" :href="it" class="notes-down" target="_blank">
              讲义下载{{ix+1}}
            </a>
          </div>
        </div>
        <div class="right-box" v-if="item.type == 2">
          <div class="box1" style="justify-content: flex-start; width: 100%;">
            <div class="box1-left">
              <img src="https://shijizhongshi-image.obs.cn-north-4.myhuaweicloud.com/2022/10/27/2824444072674986593/657b37c170281053d49d5cb90afd3f5.png" alt="">
            </div>
            <div class="box1-right">
              <!-- <div class="live-type-name"> {{item.cate_name}} </div> -->
              <div>
                <router-link :to="{ name: 'Liveroom', params: { lid: item.id } }">
                  <div class="live-name"> {{item.title}} </div>
                </router-link>
              </div>
              <div class="live-tearcher"> 直播教师：{{item.teacher}} </div>
              <div class="live-tearcher"> 开始时间：{{item.start_time}} </div>
              <div class="live-tearcher"> 结束时间：{{item.end_time}} </div>
            </div>
          </div>
          <div class="right-live">
            <div>
              <router-link :to="{ name: 'Liveroom', params: { lid: item.id } }">
                <div v-if="item.status == 1" class="live-btn"> 未开始 </div>
                <div v-if="item.status == 2" class="live-btn start-live"> 直播中 </div>
                <div v-if="item.status == 3" class="live-btn back-live"> 直播回放 </div>
              </router-link>
            </div>
          </div>
          <div v-if="item.notes" class="notesbox">
            <a v-for="(it, ix) in item.notes" :key="ix" :href="it" class="notes-down" target="_blank">
              讲义下载{{ix+1}}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getLiveList } from "../../api/api";
export default {
  data() {
    return {
      list: []
    };
  },
  created() {
    this.getLiveList();
  },
  methods: {
    getLiveList(){
      getLiveList({})
        .then(res => {
          if (res.code == 1) {
            this.list = res.data
          }else if(res.code == -2){
            this.$router.push('/login')
          }
        })
        .catch(err => {

        });
    }
  },
};
</script>


<style>
.member-main-tab {
    width: 100%;
    height: 60px;
    background: #fff;
    border-radius: 6px;
    margin-bottom: 20px;
    box-shadow: 0 0 5px rgba(0, 0, 0, .1);
    display: flex
  }

  .member-main-tab .main-tab {
    flex: 1;
    padding: 10px 20px;
    display: flex
  }

  .member-main-tab .main-tab li {
    position: relative;
    height: 40px;
    line-height: 40px;
    cursor: pointer;
    color: #666;
    padding: 0 10px;
    margin-right: 40px
  }

  .member-main-tab .main-tab li:hover {
    color: #333
  }

  .member-main-tab .main-tab li.active {
    font-weight: 700;
    color: #333
  }

  .member-main-tab .main-tab li.active:after {
    position: absolute;
    content: " ";
    color: #fff;
    background: linear-gradient(90deg, #27a3ff, #2380fb);
    width: 20px;
    height: 4px;
    border-radius: 10px;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%)
  }

  .member-main-body {
    position: relative;
    width: 100%;
    background: #fff;
    border-radius: 6px;
    min-height: 560px;
    box-shadow: 0 0 5px rgba(0, 0, 0, .1);
  }
  .live-main-body{
    padding: 30px 0;
  }

  .member-main-body .no-data {
    padding-top: 100px;
    text-align: center
  }

  .member-main-body .no-data img {
    margin: 0 auto
  }

  .member-main-body .no-data p {
    font-size: 16px;
    color: #666
  }


  .right-box {
      position: relative;
      width: 870px;
      height: 140px;
      border: 1px solid #ddd;
      margin: 0 auto;
      border-radius: 4px;
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      justify-content: space-between;
  }

  .box1 {
      width: 55%;
      height: 140px;
      display: flex;
      justify-content: flex-end;
      align-items: center
  }

  .box1-left {
      height: 112px;
      background-color: #f5f7fa;
      margin-left: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: hidden;
      border-radius: 10px;
  }

  .box1-left-name {
      width: 90%;
      text-align: center;
      text-overflow: ellipsis;
      -webkit-line-clamp: 2;
      display: -webkit-box;
      overflow: hidden;
      color: #b4bfce;
      font-weight: 700;
      font-size: 18px
  }

  .box1 .box1-left > img {
      width: auto;
      height: 100%
  }

  .box1-right {
      width: 60%;
      height: 100px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding-left: 10px
  }

  .box1-right-tiltle-courename {
      height: 25px;
      line-height: 25px
  }

  .box1-right-tiltle div:nth-child(2) {
      font-weight: 700;
      font-size: 18px
  }

  .box1-right > div.live-tearcher {
      display: flex;
      color: #666;
      font-size: 14px
  }

  .box1-right > div:nth-child(2) p:nth-child(2) {
      padding-left: 5px
  }

  .box1-right > div:nth-child(2) p:nth-child(3) {
      padding-left: 50px
  }
  .right-live {
      width: 130px;
      padding-right: 20px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: space-between;
      height: 100px
  }

  .right-live p {
      color: #999;
      font-size: 14px
  }

  .live-btn {
      width: 76px;
      padding: 3px 5px;
      background-color: rgba(0, 0, 0, .5);
      border-radius: 6px;
      color: #fff;
      font-size: 16px;
      text-align: center;
      line-height: 26px;
      cursor: pointer
  }
  .start-live{
    background-color: #F20000;
  }
  .back-live{
    background-color: #2380fb;
  }
  .live-name {
      font-size: 18px!important;
      color: #333!important;
      font-weight: 700;
      cursor: pointer;
  }
  .notesbox{
    position: absolute;
    right: 30px;
    bottom: 20px;
  }
  .notes-down{
    border: 1px solid #2d8cf0;
    padding: 3px 5px;
    border-radius: 6px;
    font-size: 16px;
    margin-left: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/member/live.vue